import { Text } from "@src/appV2/redesign/system/ui-components";

import { ScreeningSurveyInfoLayout } from "./components/ScreeningSurveyInfoLayout";

interface ScreeningSurveyWelcomeProps {
  onGetStarted: () => void;
}

export function ScreeningSurveyWelcome(props: ScreeningSurveyWelcomeProps) {
  const { onGetStarted } = props;

  return (
    <ScreeningSurveyInfoLayout
      title="Welcome!"
      icon="house-illustration"
      action={{ label: "Get Started", onClick: onGetStarted }}
    >
      <Text
        variant="h4"
        sx={(theme) => ({ textAlign: "center", color: theme.palette.text.secondary })}
      >
        Please fill out this less than 1 minute form to apply for Home Health & Hospice
        opportunities.
      </Text>
    </ScreeningSurveyInfoLayout>
  );
}
